import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import noCircleImage from '../../assets/images/sliderImage_1.png'
import { Grid } from '@material-ui/core'

const useStyles = makeStyles({
  media: {
    height: 250,
  },
})

interface INoCirclesProps {
  onGoToAddCircle: () => void
}

export const NoCircles = ({ onGoToAddCircle }: INoCirclesProps) => {
  const classes = useStyles()

  return (
    <Grid item container xs={12} sm={4}>
      <Card>
        <CardActionArea onClick={onGoToAddCircle}>
          <CardMedia
            className={classes.media}
            image={noCircleImage}
            title={'Add a group'}
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              Add your first group
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              Welcome to the Daily Dose. Create you first group here and now.
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button size="small" color="primary" onClick={onGoToAddCircle}>
            Add my first group
          </Button>
        </CardActions>
      </Card>
    </Grid>
  )
}
